/*
  Iterate over all the links in the ia_map and remove any that
  don't pass permissions checks.
*/

const IaPermissionMapper = async (iaMap:any, permissionsMap:any) => {
  const isEntitled = (link:any) => {
    return link.entitlements.find((entitlementString:string) => {
      return permissionsMap[entitlementString] && permissionsMap[entitlementString].enabled;
    });
  };

  const isPermitted = async (link:any) => {
    return link.entitlements ? Promise.resolve(isEntitled(link)) : Promise.resolve(true);
  };

  let mapLinkGroup:any;
  if (mapLinkGroup === undefined) mapLinkGroup = null;

  const mapLink = async (link:any) => {
    if (Array.isArray(link)) {
      return mapLinkGroup(link);
    }

    if (await isPermitted(link)) {
      const newLink = { ...link };
      newLink.children = await mapLinkGroup(link.children || []);
      return newLink;
    }

    return null;
  };

  mapLinkGroup = async (linkGroup:any) =>
    (await Promise.all(linkGroup.map(async (l:any) => mapLink(l)))).filter(x => !!x);

  const linkGroupPromises = Object.keys(iaMap).map(async key => {
    const result:any = {};
    result[key] = await mapLinkGroup(iaMap[key]);
    return result;
  });
  const linkGroupResults = (await Promise.all(linkGroupPromises)).reduce(
    (all, curr) => ({ ...all, ...curr }),
    {}
  );

  return linkGroupResults;
};

export default IaPermissionMapper;
